import { createSignal, onMount } from "solid-js";

export const useCheckDomReady = () => {
  const [isDomReady, setIsDomReady] = createSignal(
    typeof window !== "undefined",
  );

  onMount(() => {
    setIsDomReady(true);
  });

  return isDomReady;
};
